var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ScrollBar',{attrs:{"minHeight":250,"maxHeight":250}},_vm._l((_vm.errors),function(error){return _c('div',{key:error},[_c('Alert',{attrs:{"type":"danger"}},[_c('span',[_vm._v(" "+_vm._s(error))])])],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }